import $ from 'jquery';
import GeneralHelper from '../../00_utilities/helpers/GeneralHelper';
import 'slick-carousel';

class Slider {
    constructor(elem) {
        this.elem = elem;
        this.breakpoints = {
            'screen-xs': 576,
            'screen-sm': 768,
            'screen-md': 992,
            'screen-lg': 1260,
            'screen-xl': 1440,
        };
        this.slider = this.elem.querySelector('.slider__slide-container');
    }

    init() {
        const settings = this.assembleSliderSettings();

        if (this.slider.querySelectorAll('.slider__item').length > 1) {
            $(this.slider).slick(settings);

            this.initializeMobileSlider(settings);
            this.resizeCenterModeOnLazyload();
        }
    }

    initializeMobileSlider(settings) {
        if (this.elem.classList.contains('slider--mobile')) {
            window.addEventListener('resize', GeneralHelper.throttle((e) => {
                if (!this.slider.classList.contains('slick-initialized')
                    && $(e.currentTarget).width() < this.breakpoints['screen-md']) {
                    $(this.slider).slick(settings);
                }
            }, 200));
        }
    }

    /**
     * resize slider as on lazyload of the first two images to ensure
     * a correct slider position and slider behaviour
     * (slider initializes on wrong position if initialization happens before lazyloading)
     */
    resizeCenterModeOnLazyload() {
        let counter = 0;
        if (this.elem.classList.contains('slider--fullwidth')
            && this.elem.getAttribute('data-center-mode') === 'true') {
            document.addEventListener('lazyloaded', (e) => {
                if (this.elem.contains(e.target)) {
                    counter += 1;
                    if (counter <= 2) {
                        $(this.slider).slick('resize');
                    }
                }
            });
        }
    }

    assembleSliderSettings() {
        const buttonNextText = this.elem.getAttribute('data-slider-button-next');
        const buttonPrevText = this.elem.getAttribute('data-slider-button-prev');
        const slidesToShow = this.elem.getAttribute('data-slides-to-show')
            ? parseInt(this.elem.getAttribute('data-slides-to-show'), 10) : 1;
        const dots = this.elem.getAttribute('data-dots')
            ? JSON.parse(this.elem.getAttribute('data-dots').toLowerCase()) : false;
        const variableWidth = this.elem.getAttribute('data-variable-width')
            ? JSON.parse(this.elem.getAttribute('data-variable-width').toLowerCase()) : false;
        const centerMode = this.elem.getAttribute('data-center-mode')
            ? JSON.parse(this.elem.getAttribute('data-center-mode').toLowerCase()) : false;
        const autoplay = this.elem.getAttribute('data-autoplay')
            ? JSON.parse(this.elem.getAttribute('data-autoplay').toLowerCase()) : false;
        const autoplaySpeed = this.elem.getAttribute('data-autoplaySpeed')
            ? parseInt(this.elem.getAttribute('data-autoplaySpeed'), 10) * 1000 : 3000;

        const settings = {
            dots,
            mobileFirst: true,
            slidesToShow,
            variableWidth,
            centerMode,
            autoplay,
            autoplaySpeed,
            slidesToScroll: 1,
            infinite: true,
            prevArrow: `<button class="slick-prev slick-arrow" type="button">${buttonPrevText}</button>`,
            nextArrow: `<button class="slick-next slick-arrow" type="button">${buttonNextText}</button>`,
        };

        if (this.elem.getAttribute('data-rows') === 0) {
            settings.rows = 0;
        }

        if (this.elem.classList.contains('slider--mobile')) {
            settings.infinite = true;
            settings.responsive = [
                {
                    breakpoint: this.breakpoints['screen-xs'] - 1, // https://github.com/kenwheeler/slick/issues/2503
                    settings: {
                        slidesToShow: 2,
                    },
                },
                {
                    breakpoint: this.breakpoints['screen-md'] - 1, // https://github.com/kenwheeler/slick/issues/2503
                    settings: 'unslick',
                },
            ];
        }

        if (this.elem.querySelectorAll('.slider__info').length) {
            $(this.slider).on('init reInit afterChange', (event, slick, currentSlide = 0) => {
                const i = currentSlide + 1;
                $(this.elem).find('.slider__info-current').text(i.toString().padStart(2, '0'));
            });
        }

        return settings;
    }
}

export default Slider;
